function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.243 6.768a.645.645 0 01-.172.426l-5.846 5.883a.676.676 0 01-.919.024.622.622 0 01-.025-.876l4.8-4.838H1.408c-.36 0-.65-.277-.65-.619 0-.342.29-.62.65-.62h16.675l-4.8-4.837c-.234-.236-.214-.645.024-.876.248-.238.686-.211.919.024l5.846 5.883c.155.15.162.279.172.426z"
});

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/arrow-right.9dbb4c82.svg";
export { SvgArrowRight as ReactComponent };